export default __webpack_public_path__ + "static/media/batchExportPage.25f153af.png";